(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kbw-privacy-pages"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-kbw-cookie-preferences]');
    if (!button) return;
    const error = button.closest('.kbw-privacy').querySelector('[data-kbw-cookie-error]');
    error.hidden = true;
    button.disabled = true;
    try {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('Privacy banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kbw-size-finder"] && !Shopify.designMode) return;
  try {
    
  function initKbwSizeFinders(scope) {
    scope.querySelectorAll('[data-kbw-size-finder]').forEach((finder) => {
      if (finder.dataset.initialized === 'true') return;
      finder.dataset.initialized = 'true';

      const form = finder.querySelector('.kbw-size-finder__form');
      const resultBox = finder.querySelector('.kbw-size-finder__result');
      const mobilityNote = finder.querySelector('[data-kbw-mobility-note]');

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const values = new FormData(form);
        const cats = Number(values.get('cats'));
        const weight = values.get('weight');
        const space = values.get('space');
        const style = values.get('style');
        const mobility = values.get('mobility');

        let recommendation = 'compact';
        if (weight === 'heavy') recommendation = 'mainecoon';
        else if (cats >= 3 || (cats === 2 && space !== 'compact')) recommendation = 'multi';
        else if (style === 'design' && space !== 'compact') recommendation = 'design';

        finder.querySelectorAll('[data-kbw-result]').forEach((item) => {
          item.hidden = item.dataset.kbwResult !== recommendation;
        });
        mobilityNote.hidden = mobility !== 'gentle';
        resultBox.hidden = false;
        resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        resultBox.focus({ preventScroll: true });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initKbwSizeFinders(document));
  document.addEventListener('shopify:section:load', (event) => initKbwSizeFinders(event.target));

  } catch(e) { console.error(e); }
})();
})();
